import { ThreeStateValue } from '../ThreeStateToggle';

// Tri-state filter for the permissions views. Replaces the old boolean
// "Hide Granted" toggle with: show everything, hide already-granted rows
// (surface what's missing), or show only already-granted rows (audit).
export type GrantedFilter = 'all' | 'hide-granted' | 'only-granted';

// Position mapping for the shared ThreeStateToggle (left | center | right):
//   left  (no)      → All
//   center (neutral)→ Hide Granted
//   right (yes)     → Only Granted
export const GRANTED_FILTER_LABELS = {
  no: 'All',
  neutral: 'Hide Granted',
  yes: 'Only Granted',
};

export const grantedFilterToToggle = (f: GrantedFilter): ThreeStateValue =>
  f === 'all' ? 'no' : f === 'hide-granted' ? 'neutral' : 'yes';

export const toggleToGrantedFilter = (v: ThreeStateValue): GrantedFilter =>
  v === 'no' ? 'all' : v === 'neutral' ? 'hide-granted' : 'only-granted';

// Does a row with the given grant state pass the active filter?
export const passesGrantedFilter = (filter: GrantedFilter, granted: boolean): boolean => {
  if (filter === 'hide-granted') return !granted;
  if (filter === 'only-granted') return granted;
  return true; // 'all'
};
